import Vue from 'vue'
import Vuex from 'vuex'
import { readSion, saveSion } from '@/view/public/common'
import { getWorkgroupList } from '@/apis/inputSpace/infoCategory'
import { getIncludeDelWorkgroupByUserSpy } from '@/apis/public'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    spyId: readSion('spyId') || '', // 业务菜单权限code
    planOptions: readSion('planOptions') || [], // 项目计划数据
    projectPlan: readSion('urlParams') || { planId: '', projectId: '' },
    editInfoData: readSion('editInfoData') || {}, // 编辑信息数据
    ownWorkgroupList: readSion('ownWorkgroupList') || [] //自己所属权限的工作组
  },

  mutations: {
    // 存储业务菜单权限code
    setSpyId(state, spyId) {
      state.spyId = spyId
      saveSion('spyId', spyId)
    },

    // 存储项目计划数据
    setPlanOptions(state, planOptions) {
      saveSion('planOptions', planOptions)
      state.planOptions = planOptions
    },

    // 存储选择的项目计划
    setProjectPlan(state, projectPlan) {
      saveSion('projectPlan', projectPlan)
      state.projectPlan = projectPlan
    },

    // 编辑信息数据
    setEditInfoData(state, obj) {
      state.editInfoData = obj
      saveSion('editInfoData', obj)
    },

    // 缓存自己所属权限的工作组
    setOwnWorkgroupList(state, ownWorkgroupList) {
      state.ownWorkgroupList = ownWorkgroupList
      saveSion('ownWorkgroupList', ownWorkgroupList)
    }
  },

  actions: {
    // 异步获取工作组信息
    async getWorkgroupListByOwn({ commit, state }, isIncludeDel = false) {
      try {
        const { userId } = readSion('userInfo') || {}
        if (!userId) return // 没有用户Id

        const params = {
          current: 1,
          pageSize: 9999,
          uesrId: userId,
          spyRightCode: state.spyId
        }
        const res = !isIncludeDel
          ? await getWorkgroupList(params)
          : await getIncludeDelWorkgroupByUserSpy(params)

        if (res.result) {
          commit('setOwnWorkgroupList', res.data || [])
        } else {
          console.error('获取工作组信息失败:', res.message)
        }
      } catch (error) {
        console.error('获取工作组信息时发生错误:', error)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js